// App-wide status color convention — every status chip / count maps to one of these
// five lifecycle buckets. Reference these instead of raw MUI color strings so new
// statuses stay consistent.
//
//   DRAFT      (grey)   — Draft, Inactive
//   OPEN       (blue)   — Open, To Do (needs attention to start)
//   INPROGRESS (orange) — In Progress, Mitigating, Pending Acceptance, Done (awaiting
//                         verification), Pending invite, Review
//   COMPLETE   (green)  — Completed, Accepted, Verified, Active
//   ERROR      (red)    — Overdue, Rejected, Suspended, Error, Terminated
//
// Red is reserved strictly for problem states — criticality/zone chips (e.g. 1B)
// keep their own risk-level colors and are not part of this convention.
export const STATE_COLORS = Object.freeze({
  DRAFT: 'default',
  OPEN: 'info',
  INPROGRESS: 'warning',
  COMPLETE: 'success',
  ERROR: 'error',
});
